import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

@Component({
  templateUrl: './loading-modal.component.html'
})

export class LoadingModalComponent implements OnInit {
  message;

  constructor(
    public activeModal: NgbActiveModal,
    private translate: TranslateService
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.carregarDados();
    });
  }

  ngOnInit() {
    this.carregarDados();
  }

  carregarDados() {
    const language = this.translate.currentLang;
    if (language === 'pt') {
      this.message = 'Carregando...';
    } else if (language === 'es') {
      this.message = 'Cargando...';
    } else if (language === 'en') {
      this.message = 'Loading...';
    } else {
      this.message = 'Loading...';
    }
  }

}
